import IntegerInput from 'components/field/IntegerInput';

import * as S from './FilterInput.styled';

/**
 * @author Burak Unsal
 */
const DynamicListNumberInput = (props) => {
	const { value, setValue, onEnterKeyDown, autoFocus = true, ...moreProps } = props;

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			onEnterKeyDown && onEnterKeyDown();
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const clipboardData = e.clipboardData;
		const pastedText = clipboardData.getData('text').trim();
		const cursorStartPosition = e.target.selectionStart;
		const cursorEndPosition = e.target.selectionEnd;
		const newValue = value.substring(0, cursorStartPosition) + pastedText + value.substring(cursorEndPosition);
		setValue(newValue);
	};

	return (
		<S.InputContainer {...moreProps}>
			<IntegerInput
				autoFocus={autoFocus}
				value={value}
				setValue={setValue}
				onKeyDown={handleKeyDown}
				onPaste={handlePaste}
				className="table-number-input"
				showArrows={false}
			/>
		</S.InputContainer>
	);
};

export default DynamicListNumberInput;
